'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _htmlGenres_navHtml = require('./html/genres_nav.html');

var _htmlGenres_navHtml2 = _interopRequireDefault(_htmlGenres_navHtml);

var GenresDirective = (function () {
    function GenresDirective($location) {
        _classCallCheck(this, GenresDirective);

        this.$location = $location;

        this.replace = true;
        this.transclude = true;
        this.template = _htmlGenres_navHtml2['default'];
        this.restrict = 'E';
        this.controller = 'GenresNavController';
        this.controllerAs = 'vm';
        this.bindToController = true;
    }

    _createClass(GenresDirective, [{
        key: 'link',
        value: function link($scope, element, attrs) {
            element.find('a').ripples();
        }
    }]);

    return GenresDirective;
})();

exports['default'] = GenresDirective;

GenresDirective.$inject = ['$location'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/genres_directive.js
 ** module id = 53
 ** module chunks = 0
 **/